<!--店铺管理-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="140px">
          <el-form-item label="账号名:">
            <el-input v-model="queryParam.name" placeholder="输入账号"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">添加店铺管理员账号</el-button>
      </div>
    </div>
    <div class="table-container" shadow="never" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        max-height="500"
        v-loading="listLoading" border>
        <el-table-column prop="loginAccount" label="账号" ></el-table-column>
        <el-table-column prop="name" label="账号名" ></el-table-column>
        <el-table-column prop="phone" label="管理员手机号" ></el-table-column>
        <el-table-column prop="createTime" label="账号创建时间" ></el-table-column>
        <el-table-column prop="lastLoginDate" label="上次登录时间" ></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click.native.prevent="showChangeDlg(scope.$index, tableData)" type="warning" size="small" plain>修改密码</el-button>
            <el-button @click.native.prevent="pathToAdminMenu(scope.row)" type="danger" size="small" plain>权限</el-button>
            <el-button v-if="scope.row.marketRuleFlag" type="warning" size="small" plain @click.native.prevent="changeMarketRule(scope.row,'2')" >取消营销</el-button>
            <el-button v-else type="warning" size="small" plain @click.native.prevent="changeMarketRule(scope.row,'1')">授权营销</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
      title="管理员信息"
      :visible.sync="visibleDlgInfo"
      width="50%"
      center>
      <div class="root-container">
        <el-row>
          <el-col :span="8"><div style="margin-top: 10px;margin-left: 30px">管理员姓名:</div></el-col>
          <el-col :span="16">
            <el-input v-model="adminInfo.name" placeholder="输入管理员姓名" style="width: 300px;"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgInfo = false">取消</el-button>
        <el-button type="primary" @click="visibleDlgInfo = false">确认</el-button>
      </span>
    </el-dialog>
    <!--    添加-->
    <el-dialog
      title="添加店铺管理员"
      :visible.sync="visibleDlg"
      width="50%"
      center>
      <store-admin-detail
        :detail-param="createParam"
        :create-type=1
        @onBtnOK="onBtnOK"
        @onStoreAdmin="onStoreAdmin"
        @onBtnCancel="onBtnCancel()"
      >

      </store-admin-detail>
    </el-dialog>
    <el-dialog
      title="修改账号密码"
      :visible.sync="visibleDlgChangePasswd"
      width="50%"
      center>
      <div class="root-container">
        <el-form ref="registerRef"  :model="changePasswdParam" :rules="rules" label-width="140px">
          <el-form-item  label="管理员姓名:" >
            <el-input style="width: 300px" v-model="changePasswdParam.name" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item  label="账号:">
            <el-input style="width: 300px" v-model="changePasswdParam.loginAccount" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item  label="新密码:" >
            <el-input v-model="changePasswdParam.newPasswd" placeholder="输入新密码"></el-input>
          </el-form-item>
          <el-form-item  label="确认密码:" >
            <el-input v-model="changePasswdParam.confirmPasswd" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgChangePasswd = false">取消</el-button>
        <el-button type="primary" @click="handleChangePasswd() ">确定修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>

  import StoreAdminDetail from "../../superadmin/components/StoreAdminDetail";
  import commonUtils from "../../../utils/commonUtils";
  import {changeAdminPasswd, delAdmin, fechListStoreAdmin} from "../../../api/superAdmin";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";
  import {addChildAdmin, qlStoreAdmin} from "../../../api/storeAdmin";
  import {changeMarketRule} from "../../../api/loginAdmin";

  export default {
    components: { StoreAdminDetail },
    data() {
      return {

        listLoading: false,
        //弹窗
        visibleDlg: false,
        visibleDlgAdd:false,
        visibleDlgInfo:false,
        visibleDlgChangePasswd:false,

        //发送短信
        timerSendCodeTip :'发送短信',

        //查询参数
        queryParam: {

          name: null,  //账号名
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },


        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],



        adminInfo :{

        },

        //添加参数
        createParam :{

        },
        //修改账号密码
        changePasswdParam:{},

        //删除
        deleteParam :{
        },

      }
    },
    mounted() {

    },
    created() {
      this.flechList();
    },
    methods: {
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      flechList(){
        this.listLoading = true;
        let param = {
          name:  this.queryParam.name,  //输入店长名
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }

        qlStoreAdmin(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);
          this.listLoading = false;
        })
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          if (commonUtils.isObjectNull(list[i].shopFrontId)) {
            list[i].shopFrontTitle = "暂无店铺";
          }
          let data = {
            number : i+1 ,
            id: list[i].id,
            name:list[i].name,
            phone: list[i].phone,
            loginAccount :  list[i].loginAccount,
            createTime :list[i].createTime,
            lastLoginDate:list[i].lastLoginDate,
            createAdminId : list[i].createAdminId,
            createAdminName :list[i].createAdminName,
            validDate: list[i].validDate,
            shopFrontId: list[i].shopFrontId,
            shopFrontTitle : list[i].shopFrontTitle,
            remark: list[i].remark,
            marketRuleFlag:list[i].marketRuleFlag,
          };
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },

      handleSelectionChange(val) {

      },

      changeMarketRule(row,type){
        let message = "确认取消授权？"
        if(type === "1"){
          message = "确认授权？"
        }
        this.$confirm(message, "配置", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
          let param = {
            type: type,
            adminId:row.id,
          };
          changeMarketRule(param).then(response =>
          {
            if (response.code == 20000){
              messageUtils.successMsg(this,"配置成功");
            }else {
              messageUtils.errorMsg(this,"配置失败");
            }
            this.flechList();
          })
        });
      },

      onBtnOK(){
        this.visibleDlg = false;
        this.flechList();
      },

      onStoreAdmin(data){

        data.createAdminId = globaldata.getAdminStore().id;
        data.storeFrontId =globaldata.getAdminStore().storeFrontId;
        data.phone = 0;

        addChildAdmin(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.flechList();
        })

      },
      onBtnCancel(){
        this.visibleDlg = false;
      },

      //添加一个
      handleCreateOne(){
        this.visibleDlg = true;
      },

      //详细信息
      onbtnGetInfo(index,tableData){

        this.visibleDlgInfo = this;
      },

      //修改密码
      showChangeDlg(index,tableData){
        this.visibleDlgChangePasswd = true;
        this.changePasswdParam = {
          id: tableData[index].id,
          name:tableData[index].name,
          phone:tableData[index].phone,
          loginAccount:tableData[index].loginAccount,
          newPasswd:"",
          confirmPasswd:"",
          vccCode :''
        }
      },
      //修改密码
      handleChangePasswd(){
        this.checkChangValied(this.callCheckChangValied);
      },

      callCheckChangValied(msg,ok){
        if (ok ==false){
          this.$message({
            message: msg,
            type: 'warning'
          });
          return;
        }
        let changeParam = {
          id: this.changePasswdParam.id,
          passwd:this.changePasswdParam.newPasswd,
          confirmPasswd:this.changePasswdParam.confirmPasswd,
          vccCode:this.changePasswdParam.vccCode
        };
        changeAdminPasswd(changeParam).then(response =>
        {
          if (response.data == true){
            messageUtils.successMsg(this,"修改成功");
            this.visibleDlgChangePasswd = false;
          }else {
            messageUtils.errorMsg(this,"修改失败");
          }
        })

      },

      checkChangValied(callback ){
        let errorMsg;
        let ok = false;
        if (commonUtils.isStringNull(this.changePasswdParam.newPasswd)
          ||commonUtils.isStringNull(this.changePasswdParam.confirmPasswd)
        ){
          errorMsg = "密码不一致或格式错误";
          if (callback){
            callback(errorMsg,ok);
          }
          return;
        }
        if (commonUtils.isStringNull(this.changePasswdParam.vccCode)
        ){
          // errorMsg = "请输入验证码";
          // if (callback){
          //   callback(errorMsg,ok);
          // }
          // return;
        }
        callback("",true);
      },

      //修改备注
      onbtnChangeRemark(index,tableData){
        this.$message('选择了 : ' + index);
      },
      //菜单权限
      pathToAdminMenu(row){
        let query = {
          adminId:row.id,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          storeAdminId:globaldata.getAdminStore().id
        }
        this.$router.push({path:'/ums/allocMenuToAdmin',query:query})
      },


      handleCurrentChange(val) {

        this.queryParam.pageNum = val;
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/ums/admin/index.vue